import {Action, Catalog} from '../../../../common/types/common';
import {FieldSummary} from '../../../types/mx/epics';
import {GroupFormDTO} from '../../types/mx/epics';
import {GroupFormViewFieldErrorState} from '../../types/mx/reducers';

export const GROUP_CHANGE_NAME_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_NAME_MX_ACTION',
    action: (name: string, error: string = null) => ({
        name, error,
        type: GROUP_CHANGE_NAME_MX_ACTION.name
    })
};

export const GROUP_NAME_OK_MX_ACTION: Action = {
    name: 'GROUP_NAME_OK_MX_ACTION',
    action: (name: string, error: string = null) => ({
        name, error,
        type: GROUP_NAME_OK_MX_ACTION.name
    })
};

export const GROUP_CHANGE_PTX_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_PTX_MX_ACTION',
    action: (ptxId: string, error: string = null) => ({
        ptxId, error,
        type: GROUP_CHANGE_PTX_MX_ACTION.name
    })
};

export const GROUP_CHANGE_ADDRESS_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_ADDRESS_MX_ACTION',
    action: (address: string, error: string = null) => ({
        address, error,
        type: GROUP_CHANGE_ADDRESS_MX_ACTION.name
    })
};

export const GROUP_CHANGE_SUPERVISOR_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_SUPERVISOR_MX_ACTION',
    action: (supervisor: Catalog, error: string = null) => ({
        supervisor, error,
        type: GROUP_CHANGE_SUPERVISOR_MX_ACTION.name
    })
};

export const GROUP_CHANGE_ADVISER_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_ADVISER_MX_ACTION',
    action: (adviser: Catalog, error: string = null) => ({
        adviser, error,
        type: GROUP_CHANGE_ADVISER_MX_ACTION.name
    })
};

export const GROUP_CHANGE_MARKET_NAME_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_MARKET_NAME_MX_ACTION',
    action: (marketName: Catalog, error: string = null) => ({
        marketName, error,
        type: GROUP_CHANGE_MARKET_NAME_MX_ACTION.name
    })
};

export const GROUP_CHANGE_EXTERNAL_ADVISER_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_EXTERNAL_ADVISER_MX_ACTION',
    action: (externalAdviser: Catalog, error: string = null) => ({
        externalAdviser, error,
        type: GROUP_CHANGE_EXTERNAL_ADVISER_MX_ACTION.name
    })
};

export const GROUP_CHANGE_POSTAL_CODE_ACTION: Action = {
    name: 'GROUP_CHANGE_POSTAL_CODE_ACTION',
    action: (postalCode: string, country: string, error: string) => ({
        postalCode, country, error,
        type: GROUP_CHANGE_POSTAL_CODE_ACTION.name
    })
};

export const GROUP_CHANGE_PHONE_WHATSAPP_ACTION: Action = {
    name: 'GROUP_CHANGE_PHONE_WHATSAPP_ACTION',
    action: (whatsappNumber: string, country: string, error: string) => ({
        whatsappNumber, country, error,
        type: GROUP_CHANGE_PHONE_WHATSAPP_ACTION.name
    })
};

export const GROUP_CHANGE_STATES_ACTION: Action = {
    name: 'GROUP_CHANGE_STATES_ACTION',
    action: (state: Catalog, error: string = null) => ({
        state, error,
        type: GROUP_CHANGE_STATES_ACTION.name
    })
};

export const GROUP_CHANGE_CITY_ACTION: Action = {
    name: 'GROUP_CHANGE_CITY_ACTION',
    action: (city: Catalog, error: string = null) => ({
        city, error,
        type: GROUP_CHANGE_CITY_ACTION.name
    })
};

export const GROUP_CHANGE_MUNICIPALITY_ACTION: Action = {
    name: 'GROUP_CHANGE_MUNICIPALITY_ACTION',
    action: (municipality: Catalog, error: string = null) => ({
        municipality, error,
        type: GROUP_CHANGE_MUNICIPALITY_ACTION.name
    })
};

export const GROUP_CHANGE_COLONIES_ACTION: Action = {
    name: 'GROUP_CHANGE_COLONIES_ACTION',
    action: (colonies: Catalog[], error: string = null) => ({
        colonies, error,
        type: GROUP_CHANGE_COLONIES_ACTION.name
    })
};

export const GROUP_CHANGE_COLONY_ACTION: Action = {
    name: 'GROUP_CHANGE_COLONY_ACTION',
    action: (colony: Catalog, error: string = null) => ({
        colony, error,
        type: GROUP_CHANGE_COLONY_ACTION.name
    })
};

export const NOT_FOUND_LOCATION_ERROR_GROUP_ACTION: Action = {
    name: 'NOT_FOUND_LOCATION_ERROR_GROUP_ACTION',
    action: () => ({
        type: NOT_FOUND_LOCATION_ERROR_GROUP_ACTION.name
    })
};

export const GROUP_CHANGE_GROUP_TYPE_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_GROUP_TYPE_MX_ACTION',
    action: (groupType: Catalog, error: string = null) => ({
        groupType, error,
        type: GROUP_CHANGE_GROUP_TYPE_MX_ACTION.name
    })
};

export const GROUP_CHANGE_INVENTORY_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_INVENTORY_MX_ACTION',
    action: (inventory: Catalog, error: string = null) => ({
        inventory, error,
        type: GROUP_CHANGE_INVENTORY_MX_ACTION.name
    })
};

export const GROUP_CHANGE_USERS_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_USERS_MX_ACTION',
    action: (users: string[], error: string = null) => ({
        users, error,
        type: GROUP_CHANGE_USERS_MX_ACTION.name
    })
};

export const GROUP_CHANGE_GROUP_LIST_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_GROUP_LIST_MX_ACTION',
    action: (groupList: Catalog, error: string = null) => ({
        groupList, error,
        type: GROUP_CHANGE_GROUP_LIST_MX_ACTION.name
    })
};

export const GROUP_CHANGE_WARRANTY_STATUS_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_WARRANTY_STATUS_MX_ACTION',
    action: (warrantyStatus: boolean, error: string = null) => ({
        warrantyStatus, error,
        type: GROUP_CHANGE_WARRANTY_STATUS_MX_ACTION.name
    })
};

export const GROUP_CHANGE_PAYMENT_TYPE_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_PAYMENT_TYPE_MX_ACTION',
    action: (paymentType: Catalog, error: string = null) => ({
        paymentType, error,
        type: GROUP_CHANGE_PAYMENT_TYPE_MX_ACTION.name
    })
};

export const GROUP_CHANGE_BILLING_MAIL_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_BILLING_MAIL_MX_ACTION',
    action: (billingMail: string, error: string = null) => ({
        billingMail, error,
        type: GROUP_CHANGE_BILLING_MAIL_MX_ACTION.name
    })
};

export const GROUP_CHANGE_CREDIT_STATUS_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_CREDIT_STATUS_MX_ACTION',
    action: (creditStatus: boolean, error: string = null) => ({
        creditStatus, error,
        type: GROUP_CHANGE_CREDIT_STATUS_MX_ACTION.name
    })
};

export const GROUP_CHANGE_INSURANCE_STATUS_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_INSURANCE_STATUS_MX_ACTION',
    action: (insuranceStatus: boolean, error: string = null) => ({
        insuranceStatus, error,
        type: GROUP_CHANGE_INSURANCE_STATUS_MX_ACTION.name
    })
};

export const GROUP_CHANGE_QUOTE_STATUS_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_QUOTE_STATUS_MX_ACTION',
    action: (quoteStatus: boolean, error: string = null) => ({
        quoteStatus, error,
        type: GROUP_CHANGE_QUOTE_STATUS_MX_ACTION.name
    })
};

export const GROUP_CHANGE_PREMIUM_INVENTORY_STATUS_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_PREMIUM_INVENTORY_STATUS_MX_ACTION',
    action: (premiumInventoryStatus: boolean, error: string = null) => ({
        premiumInventoryStatus, error,
        type: GROUP_CHANGE_PREMIUM_INVENTORY_STATUS_MX_ACTION.name
    })
};

export const GROUP_CHANGE_BIOMETRICS_ENABLED_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_BIOMETRICS_ENABLED_MX_ACTION',
    action: (biometricsEnabled: boolean, error: string = null) => ({
        biometricsEnabled, error,
        type: GROUP_CHANGE_BIOMETRICS_ENABLED_MX_ACTION.name
    })
};

export const GROUP_CHANGE_EXPRESS_PROFILER_STATUS_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_EXPRESS_PROFILER_STATUS_MX_ACTION',
    action: (expressProfilerStatus: boolean, error: string = null) => ({
        expressProfilerStatus, error,
        type: GROUP_CHANGE_EXPRESS_PROFILER_STATUS_MX_ACTION.name
    })
};

export const GROUP_CHANGE_APPROVALS_STATUS_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_APPROVALS_STATUS_MX_ACTION',
    action: (approvalsStatus: boolean, error: string = null) => ({
        approvalsStatus, error,
        type: GROUP_CHANGE_APPROVALS_STATUS_MX_ACTION.name
    })
};

export const GROUP_CHANGE_CALCULATOR_PREMIUM_INVENTORY_ENABLED_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_CALCULATOR_PREMIUM_INVENTORY_ENABLED_MX_ACTION',
    action: (calculatorPremiumInventoryEnabled: Catalog, error: string = null) => ({
        calculatorPremiumInventoryEnabled, error,
        type: GROUP_CHANGE_CALCULATOR_PREMIUM_INVENTORY_ENABLED_MX_ACTION.name
    })
};

export const GROUP_CHANGE_MOTORFY_STATUS_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_MOTORFY_STATUS_MX_ACTION',
    action: (status: boolean, error: string = null) => ({
        status, error,
        type: GROUP_CHANGE_MOTORFY_STATUS_MX_ACTION.name
    })
};

export const GROUP_CHANGE_COPPEL_STATUS_MX_ACTION: Action = {
    name: 'GROUP_CHANGE_COPPEL_STATUS_MX_ACTION',
    action: (status: boolean, error: string = null) => ({
        status, error,
        type: GROUP_CHANGE_COPPEL_STATUS_MX_ACTION.name
    })
};

export const GROUP_FORM_SET_STATE_ACTION: Action = {
    name: 'GROUP_FORM_SET_STATE_ACTION',
    action: (fieldSummary: FieldSummary<GroupFormDTO, GroupFormViewFieldErrorState>) => ({
        fieldSummary,
        type: GROUP_FORM_SET_STATE_ACTION.name
    })
};

export const GROUP_SAVE_INFO_MX_ACTION: Action = {
    name: 'GROUP_SAVE_INFO_MX_ACTION',
    action: (groupId: string = null) => ({
        groupId,
        type: GROUP_SAVE_INFO_MX_ACTION.name
    })
};

export const GROUP_ON_PRESS_ADD_GROUP_MX_ACTION: Action = {
    name: 'GROUP_ON_PRESS_ADD_GROUP_MX_ACTION',
    action: () => ({
        type: GROUP_ON_PRESS_ADD_GROUP_MX_ACTION.name
    })
};

export const GROUP_ON_PRESS_MIGRATE_MX_ACTION: Action = {
    name: 'GROUP_ON_PRESS_MIGRATE_MX_ACTION',
    action: (groupId: string = null) => ({
        groupId,
        type: GROUP_ON_PRESS_MIGRATE_MX_ACTION.name
    })
};

export const GROUP_LOADING_DISABLE_SUCCESS_ACTION: Action = {
    name: 'GROUP_LOADING_DISABLE_SUCCESS_ACTION',
    action: (payload: any) => ({
        payload,
        type: GROUP_LOADING_DISABLE_SUCCESS_ACTION.name
    })
};

export const GROUP_LOADING_ENABLE_ACTION: Action = {
    name: 'GROUP_LOADING_ENABLE_ACTION',
    action: (payload: any) => ({
        payload,
        type: GROUP_LOADING_ENABLE_ACTION.name
    })
};

export const GROUP_MIGRATION_REQUEST_ACTION: Action = {
    name: 'GROUP_MIGRATION_REQUEST_ACTION',
    action: () => ({
        type: GROUP_MIGRATION_REQUEST_ACTION.name
    })
};

export const GROUP_MIGRATION_REQUEST_SUCCESSFUL_ACTION: Action = {
    name: 'GROUP_MIGRATION_REQUEST_SUCCESSFUL_ACTION',
    action: () => ({
        type: GROUP_MIGRATION_REQUEST_SUCCESSFUL_ACTION.name
    })
};

export const GROUP_DELETE_REQUEST_ACTION: Action = {
    name: 'GROUP_DELETE_REQUEST_ACTION',
    action: () => ({
        type: GROUP_DELETE_REQUEST_ACTION.name
    })
};

export const GROUP_SYNC_FORCEMANAGER_ACTION: Action = {
    name: 'GROUP_SYNC_FORCEMANAGER_ACTION',
    action: () => ({
        type: GROUP_SYNC_FORCEMANAGER_ACTION.name
    })
};

export const GROUP_SYNC_FORCEMANAGER_SUCCESS_ACTION: Action = {
    name: 'GROUP_SYNC_FORCEMANAGER_SUCCESS_ACTION',
    action: () => ({
        type: GROUP_SYNC_FORCEMANAGER_SUCCESS_ACTION.name
    })
};

export const GROUP_SYNC_FORCEMANAGER_ERROR_ACTION: Action = {
    name: 'GROUP_SYNC_FORCEMANAGER_ERROR_ACTION',
    action: (error: string) => ({
        error,
        type: GROUP_SYNC_FORCEMANAGER_ERROR_ACTION.name
    })
};

export const GROUP_USER_REMOVE_GROUP_MX_ACTION: Action = {
    name: 'GROUP_USER_REMOVE_GROUP_MX_ACTION',
    action: (groupId: string, userId: string, error: string = null) => ({
        groupId, userId, error,
        type: GROUP_USER_REMOVE_GROUP_MX_ACTION.name
    })
};
